import React from 'react';
import clsx from 'clsx';
import Skeleton from '../../../components/Skeleton';
import WithdrawText from './WithdrawText';
import type { IWithdrawBreakdownData } from '../../../interfaces/Withdrawal';
import styles from '../styles.module.css';

interface BreakdownCardProps {
  data?: IWithdrawBreakdownData;
  isLoading?: boolean;
}

/**
 * Renders `breakDowns[]` exactly as the server sends them —
 * no client-side arithmetic, matching Android.
 */
const BreakdownCard: React.FC<BreakdownCardProps> = ({ data, isLoading }) => {
  if (isLoading && !data) {
    return (
      <div className={styles.breakdownCard}>
        <Skeleton variant="sm-text" />
        <Skeleton variant="sm-text" />
        <Skeleton variant="text" />
      </div>
    );
  }

  // `totalData` is the CTA label (its icon is literally "upilogooncta"), not a
  // row in this card — the withdraw button renders it.
  const rows = data?.breakDowns ?? [];
  if (!rows.length) return null;

  return (
    <div className={clsx(styles.breakdownCard, isLoading && styles.isStale)}>
      {rows.map((row, index) => (
        <div className={styles.breakdownRow} key={index}>
          <WithdrawText data={row.keyData} className="fontSizeSm14" />
          <WithdrawText
            data={row.valueData}
            className={clsx(styles.breakdownValue, 'fontSizeSm14')}
          />
        </div>
      ))}
    </div>
  );
};

export default BreakdownCard;
